module.exports = __webpack_public_path__ + "static/media/REENA JI.a2b48842.jpg";